// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__SAz7m","label":"Checkbox_label__HOtJU","message":"Checkbox_message__qp5og","disabled":"Checkbox_disabled__LYRDm"};